<template>
	<div>
    <div class="main">
      <channel-banner></channel-banner>
      <!-- 支持与服务 -->
      <div class="content">
        <div class="item">
          <img src="../../../assets/channel/service/banner_01.png" alt="">
          <div class="item_title">在线客服</div>
          <div class="item_button" @click="enterDetail">点击进入</div>
        </div>
        <div class="item">
          <img src="../../../assets/channel/service/banner_02.png" alt="">
          <div class="item_title">常见问题及解决方案</div>
          <div class="item_button" @click="enterDetail">点击进入</div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
    import ChannelBanner from '../../../components/channel/channelBanner.vue'
    export default {
        components: {
          ChannelBanner
        },
        methods: {
          enterDetail() {
            this.$router.push({path: '/commonProblem'})
          }
        },
    }
</script>

<style lang="scss" scoped="scoped">
.main {
  margin-top: 80px;
  .content {
    display: flex;
    justify-content: space-between;
    width: 70%;
    margin: auto;
    .item {
      position: relative;
      width: 48%;
      height: 220px;
      margin: 100px 0;
      border: 1px solid #E5E5E5;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
      img {
        width: 100%;
        height: 112px;
      }
      .item_title {
        position: absolute;
        top: 35px;
        left: 40px;
        font-size: 28px;
        color: #fff;
      }
      .item_button {
        position: absolute;
        bottom: 30px;
        left: 15%;
        width: 70%;
        height: 35px;
        border: 1px solid #5984EC;
        font-size: 14px;
        color: #5984EC;
        text-align: center;
        line-height: 35px;
      }
      .item_button:hover {
        cursor: pointer;
      }
    }
    .item:hover {
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.2);
    }
  }
}
</style>